/**
 * Desktop (landscape, 16:9) versions of the world maps, outpainted from the
 * portrait originals. Node coordinates are fractions of the wide art, in
 * lesson order (first stop first). Phones keep the portrait art + its coords.
 */
export const WIDE_MAP_ASPECT = 1344 / 768;

export const WIDE_MAPS = {
  garden_world_screen_background: {
    art: "garden_world_screen_background_wide",
    nodes: [
      { x: 0.16, y: 0.9 }, { x: 0.4, y: 0.88 }, { x: 0.62, y: 0.8 }, { x: 0.78, y: 0.6 }, { x: 0.85, y: 0.44 },
    ],
  },
  ocean_world_screen_background: {
    art: "ocean_world_screen_background_wide",
    nodes: [
      { x: 0.25, y: 0.88 }, { x: 0.42, y: 0.74 }, { x: 0.52, y: 0.58 }, { x: 0.66, y: 0.46 }, { x: 0.82, y: 0.34 },
    ],
  },
  sky_world_screen_background: {
    art: "sky_world_screen_background_wide",
    nodes: [
      { x: 0.15, y: 0.85 }, { x: 0.32, y: 0.7 }, { x: 0.5, y: 0.56 }, { x: 0.68, y: 0.44 }, { x: 0.85, y: 0.3 },
    ],
  },
  star_world_screen_background: {
    art: "star_world_screen_background_wide",
    nodes: [
      { x: 0.2, y: 0.9 }, { x: 0.38, y: 0.78 }, { x: 0.52, y: 0.63 }, { x: 0.67, y: 0.48 }, { x: 0.82, y: 0.33 },
    ],
  },
  rainbow_world_screen_background: {
    art: "rainbow_world_screen_background_wide",
    nodes: [
      { x: 0.26, y: 0.9 }, { x: 0.4, y: 0.78 }, { x: 0.52, y: 0.66 }, { x: 0.6, y: 0.54 }, { x: 0.66, y: 0.43 }, { x: 0.72, y: 0.33 },
    ],
  },
  "counting/worlds/counting_meadow_world": {
    art: "counting/worlds/counting_meadow_world_wide",
    nodes: [
      { x: 0.25, y: 0.8 }, { x: 0.52, y: 0.68 }, { x: 0.78, y: 0.48 },
    ],
  },
  "counting/worlds/counting_number_garden": {
    art: "counting/worlds/counting_number_garden_wide",
    nodes: [{ x: 0.44, y: 0.88 }, { x: 0.56, y: 0.7 }, { x: 0.46, y: 0.52 }, { x: 0.54, y: 0.35 }],
  },
  "counting/worlds/counting_ten_town": {
    art: "counting/worlds/counting_ten_town_wide",
    nodes: [{ x: 0.15, y: 0.86 }, { x: 0.5, y: 0.8 }, { x: 0.8, y: 0.55 }],
  },
  writing_town_path_bg: {
    art: "writing_town_path_bg_wide",
    nodes: [
      { x: 0.4, y: 0.9 }, { x: 0.5, y: 0.84 }, { x: 0.44, y: 0.77 }, { x: 0.56, y: 0.7 }, { x: 0.5, y: 0.63 }, { x: 0.62, y: 0.56 }, { x: 0.56, y: 0.48 }, { x: 0.68, y: 0.41 }, { x: 0.62, y: 0.33 }, { x: 0.72, y: 0.25 }, { x: 0.66, y: 0.16 },
    ],
  },
};

/** Returns { art, aspect, nodes } for a portrait art key, or null. */
export function wideMapFor(artKey) {
  const w = WIDE_MAPS[artKey];
  return w ? { art: w.art, aspect: WIDE_MAP_ASPECT, nodes: w.nodes } : null;
}
